import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Less_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36 20C36 20.5523 35.5523 21 35 21L5 21C4.44772 21 4 20.5523 4 20C4 19.4477 4.44772 19 5 19L35 19C35.5523 19 36 19.4477 36 20Z"
            />
        </SvgStyled>
    );
};

export default Less_xl;
